/* A simplified version of getOffset from dom-lib (https://github.com/rsuite/dom-lib/blob/master/src/query.js) */
export default function getOffset(node) {
  const docElem = document && document.documentElement;
  let box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };

  if (!document) {
    return box;
  }
  if (node.getBoundingClientRect !== undefined) {
    box = node.getBoundingClientRect();
  }
  if (box.width || box.height) {
    box = {
      top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
      left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
      width: (box.width === null ? node.offsetWidth : box.width) || 0,
      height: (box.height === null ? node.offsetHeight : box.height) || 0
    };
  }
  return box;
}
